<template>
  <div class="report-parent-container">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="药库报表" name="warehouse">
        <ReportCont ref="warehouseReport" :reportType="1" />
      </el-tab-pane>
      <el-tab-pane label="药房报表" name="pharmacy">
        <ReportContYF ref="pharmacyReport" :reportType="2" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportCont from './ReportCont.vue'
import ReportContYF from './ReportContYF.vue'

export default {
  name: 'ReportParent',
  components: {
    ReportCont,
    ReportContYF
  },
  data() {
    return {
      activeTab: 'warehouse'
    }
  },
  methods: {
    handleTabClick(tab) {
      const reportRef = tab.name === 'warehouse' ? 'warehouseReport' : 'pharmacyReport'
      this.$nextTick(() => {
        if (this.$refs[reportRef]) {
          this.$refs[reportRef].refreshData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.report-parent-container {
  height: calc(88vh - 20px);
  background: #f5f7fa;
  box-sizing: border-box;
  overflow: hidden;

  /deep/ .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs__content {
      flex: 1;
      overflow: hidden;

      .el-tab-pane {
        height: 100%;
        overflow: hidden;
      }
    }
  }
}
</style>